import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_WHITE,
	FONT_WT_BOLD,
	MOBILE_L_BP,
	DESKTOP_SM_BP,
	COLOR_PANTONE_GREY,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	width: 100%;
	padding: 80px 0px 110px 0px;
	display: flex;
	flex-direction: column;
	align-items: center;
	@media only screen and (max-width: ${MOBILE_L_BP + 1}px) {
		padding: 34px 0px 50px 0px;
	}
`;

export const Title = styled.h1`
	max-width: 630px;
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 28px;
	line-height: 33px;
	text-align: center;
	color: ${(p) => (p.darkBg ? COLOR_WHITE : COLOR_TEXT_PRIMARY_B2C)};

	@media only screen and (max-width: ${MOBILE_L_BP + 1}px) {
		max-width: 320px;
	}
`;

export const TabsContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 80px;
	width: 100%;

	@media only screen and (max-width: ${MOBILE_L_BP + 1}px) {
		margin-top: 0px;
	}
`;

export const CardsContainer = styled.div`
	width: 100%;
	display: flex;
	margin-top: 35px;
	flex-wrap: wrap;
	flex-direction: column;

	@media only screen and (max-width: ${MOBILE_L_BP + 1}px) {
		flex-direction: column;
	}
`;

export const Card = styled.div`
	width: 375px;
	height: 468px;
	left: 84px;
	top: 1595px;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		width: 312.5px;
		height: 390px;
		margin-bottom: 30px;
	}

	margin-left: 10px;
	margin-right: 10px;
	background: ${COLOR_WHITE};

	display: flex;
	flex-direction: column;
	align-items: center;

	.description {
		margin-top: 25px;
		margin-bottom: 25px;
		width: 233px;
		text-align: center;

		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
`;
export const TabTitle = styled.h3`
	width: 228px;
	text-align: center;
	font-weight: bold;
	font-size: 19px;
	line-height: 22px;
	text-align: center;
	text-transform: uppercase;
	margin: 0px;
	padding-bottom: 16px;
	cursor: pointer;
	color: ${(p) => (p.darkBg ? COLOR_WHITE : COLOR_TEXT_PRIMARY_B2C)};
	margin-bottom: -1px;
	border-bottom: ${(props) => (props.isActive ? "2px solid #ffffff" : "none")};
`;

export const TabTitleContainer = styled.div`
	border-bottom: 1px solid #e6e6e6;
	display: flex;
	width: 100%;
	justify-content: center;

	@media only screen and (max-width: ${MOBILE_L_BP + 1}px) {
		display: none;
	}
`;

export const ImageContainer = styled.div`
	img {
		width: 95px;
	}
	margin-top: 54px;
`;

export const CardTitle = styled.p`
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 22px;
	line-height: 76.16%;
	text-align: center;
	letter-spacing: -1px;
	margin-top: 45px;
	margin-bottom: 0px;

	color: ${COLOR_TEXT_PRIMARY_B2C};
`;

export const ExpandableCards = styled.div`
	display: none;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		display: ${(props) => props.isActive && "block!important"};
	}

	@media only screen and (min-width: ${MOBILE_L_BP + 1}px) {
		display: ${(props) => props.currentTab && "block!important"};
	}
`;

export const ExpandableTitle = styled.div`
	font-size: 18px;
	line-height: 21px;
	font-weight: ${FONT_WT_BOLD};
	color: ${COLOR_TEXT_PRIMARY_B2C};
`;

export const FlexCardsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
`;

export const ExpandContainer = styled.div`
	padding: 13px 26px 13px 26px;

	border-bottom: 1px solid ${COLOR_PANTONE_GREY};
	margin-bottom: 15px;
	display: flex;
	justify-content: space-between;

	@media only screen and (min-width: ${MOBILE_L_BP + 1}px) {
		display: none;
	}
`;

export const Arrow = styled.span`
	transform: ${(props) => (props.isActive ? "rotate(0deg)" : "rotate(180deg)")};
`;
